import React from "react";

export type Tone =
  | "success"
  | "critical"
  | "warning"
  | "info"
  | "muted"
  | "online"
  | "offline";

type Props = {
  tone: Tone;
  label?: string;
  className?: string;
};

const toneClass: Record<Tone, string> = {
  success: "bg-alert-success",
  critical: "bg-alert-critical",
  warning: "bg-alert-warning",
  info: "bg-alert-info",
  muted: "bg-ink-3",
  online: "bg-status-online",
  offline: "bg-status-offline",
};

const labelClass: Record<Tone, string> = {
  success: "text-alert-success",
  critical: "text-alert-critical",
  warning: "text-alert-warning",
  info: "text-alert-info",
  muted: "text-ink-3",
  online: "text-status-online",
  offline: "text-status-offline",
};

export default function StatusDot({ tone, label, className = "" }: Props) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <span
        aria-hidden
        className={`inline-block w-2.5 h-2.5 rounded-full ${toneClass[tone]} shadow-[0_0_0_3px_rgba(0,0,0,0.06)]`}
      />
      {label ? (
        <span className={`text-sm font-semibold ${labelClass[tone]}`}>
          {label}
        </span>
      ) : null}
    </span>
  );
}
